import { useEffect, useState } from 'react';
import { readCollection } from '../api/collections.js';

type Phone = { id: string; businessAccountId: string; maskedDisplayNumber: string; verifiedName: string; status: string; qualityRating: string | null; lastSyncedAt: string | null };
export const AccountPhones = ({ accountId }: { accountId: string }) => {
  const [expanded, setExpanded] = useState(false);
  const [phones, setPhones] = useState<Phone[] | null>(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    if (!expanded) return;
    let active = true; setError(false); setPhones(null);
    void readCollection<Phone>('/api/v1/business-accounts/' + encodeURIComponent(accountId) + '/phones')
      .then((items) => {
        if (items.some((phone) => phone.businessAccountId !== accountId)) throw new Error('Phone scope mismatch');
        if (active) setPhones(items);
      }).catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [expanded, accountId]);
  return <details className="phone-details" onToggle={(event) => setExpanded(event.currentTarget.open)}>
    <summary>Consultar números sincronizados</summary>
    {!expanded ? null : error ? <p role="alert">Não foi possível consultar os números. Feche e abra esta seção para tentar novamente.</p>
      : phones === null ? <p>Consultando números…</p> : phones.length === 0 ? <p>Nenhum número sincronizado nesta BM.</p>
      : <ul>{phones.map((phone) => <li key={phone.id}><strong>{phone.verifiedName || 'Nome não informado'}</strong><p>{phone.maskedDisplayNumber || 'Número não informado'} · Estado: {phone.status}</p>
        <p>Qualidade: {phone.qualityRating ?? 'Não informada'} · Sincronização: {phone.lastSyncedAt === null ? 'Não informada' : new Date(phone.lastSyncedAt).toLocaleString('pt-BR')}</p></li>)}</ul>}
  </details>;
};
